<template>
    <div class="form-row">
        <div class="form-group col-6">
            <label for="pump_accessory_name" v-if="index === 0">Type</label>
            <select v-model="formData.pump_accessories_list[index].name" class="form-control">
                <option class="d-none" value="">- Select -</option>
                <option value="none">Not Required</option>
                <optgroup  v-for="(group, index) in pumpAccessoriesOptions" :label="group.category" v-bind:key="index">
                    <option v-for="(item, index2) in group.items" :value="item" v-bind:key="index2">
                        {{ item }}
                    </option>
                </optgroup>
            </select>
            <span class="form-error" v-if="$v.formData.pump_accessories_list.$each[index].name.$dirty && !$v.formData.pump_accessories_list.$each[index].name.required">Required field</span>
            <button class="lists-delete" v-on:click="removePumpAccesoryRow" v-if="index !== 0"></button>
        </div>
    </div>
</template>


<script>

import { required } from 'vuelidate/lib/validators';

export default {
    name: 'PumpAccessoryRow',
    components: {
    },
    data() {
        return {
        };
    },
    props: {
        formData: {
            required: true,
        },
        index: {
            required: true,
        },
        item: {
            required: true,
        },
        pumpAccessoriesOptions: {
            required: true,
        },
    },
    validations: {
        formData: {
            pump_accessories_list: {
                $each: {
                    name: {
                        required,
                    },
                },
            },
        },
    },
    methods: {
        removePumpAccesoryRow() {
            this.formData.pump_accessories_list.splice(this.index, 1);
        },
        validateForm() {
            this.$v.$touch();
            this.$emit('pump_accessories_validation_response', !this.$v.$invalid);
        },
    },
};
</script>
